/* SMELU · Teile-Popup (20.08.2026)

   Faengt Klicks auf `a[href="#smelu-set"]` ab. Diese Links stehen in den
   FAQ-Antworten und im Akkordeon der PDP und zeigten auf die entfernte
   Section "smelu-setpieces" - also ins Leere. Statt drei Template-JSONs
   anzufassen, wird hier abgefangen. Auf Seiten ohne Popup (z. B. Startseite,
   wo die Section noch existiert) laeuft dieses Skript nicht mit, dort bleibt
   der Anker also ein normaler Anker. */
(function () {
  'use strict';

  var root, track, slides, dots, idx = 0, lastFocus = null;

  function clamp(i) { return Math.max(0, Math.min(slides.length - 1, i)); }

  function render() {
    var iEl = root.querySelector('[data-smelu-tm-index]');
    if (iEl) iEl.textContent = idx + 1;

    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);

    var prev = root.querySelector('[data-smelu-tm-prev]');
    if (prev) prev.disabled = idx === 0;

    var label = root.querySelector('[data-smelu-tm-nextlabel]');
    if (label) label.textContent = idx === slides.length - 1 ? 'Wieder von vorn' : 'Zum nächsten Teil';
  }

  function goTo(i, smooth) {
    idx = clamp(i);
    track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    render();
  }

  function next() { goTo(idx === slides.length - 1 ? 0 : idx + 1); }
  function prev() { goTo(idx - 1); }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    // erst sichtbar machen, dann die Klasse setzen, sonst greift die Transition nicht
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      goTo(0, false);
      var dlg = root.querySelector('.smelu-tm__dialog');
      if (dlg) dlg.focus();
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { root.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    root = document.querySelector('[data-smelu-tm]');
    if (!root || root.dataset.tmInit === '1') return;
    root.dataset.tmInit = '1';

    track  = root.querySelector('[data-smelu-tm-track]');
    slides = Array.prototype.slice.call(root.querySelectorAll('[data-smelu-tm-slide]'));
    dots   = Array.prototype.slice.call(root.querySelectorAll('.smelu-tm__dot'));
    if (!track || !slides.length) return;

    root.querySelectorAll('[data-smelu-tm-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    var nx = root.querySelector('[data-smelu-tm-next]');
    var pv = root.querySelector('[data-smelu-tm-prev]');
    if (nx) nx.addEventListener('click', next);
    if (pv) pv.addEventListener('click', prev);

    // Wischen: der Track scrollt selbst, wir lesen nur ab, wo er stehengeblieben ist
    var t = null;
    track.addEventListener('scroll', function () {
      window.clearTimeout(t);
      t = window.setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var c = slides[i].offsetLeft - track.offsetLeft + slides[i].offsetWidth / 2;
          var dd = Math.abs(c - mid);
          if (dd < bestD) { bestD = dd; best = i; }
        }
        if (best !== idx) { idx = best; render(); }
      }, 90);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
      else if (e.key === 'ArrowLeft')  { e.preventDefault(); prev(); }
    });

    render();
  }

  // Klick-Abfang auf die alten Anker
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#smelu-set"], [data-smelu-tm-open]');
    if (!a) return;
    if (!document.querySelector('[data-smelu-tm]')) return;   // Seite ohne Popup: Anker normal lassen
    e.preventDefault();
    e.stopPropagation();
    init();
    open();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
